let locales = {
    parameterEdit_edit: "Edit Global parameters",
    parameterEdit_create: "Create Global parameters",
    parameterEdit_key: "KEY",
    parameterEdit_description: "Description",
    parameterEdit_value: "Value",
    parameterEdit_type: "Type",
};

export default locales;